import "../body.css";

import React, { useEffect } from "react";

function IWK() {
    useEffect(() => {
        document.title = "Josiah Swanson - Invest with Knowledge";
    }, []);
    return (
        <>
            <section>
                <h2 className="centeredp">Invest with Knowledge!</h2>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I am a believer in
                    delayed gratification. One of the most powerful expressions of that
                    principle is long-term investing: the practice of putting your money
                    behind companies you genuinely believe in and waiting patiently for
                    the market to catch up to their value. Invest with Knowledge! is built
                    on the conviction that good companies, over time, perform well as
                    stocks.
                </p>
                <p style={{ textAlign: "center", marginTop: "10px", marginBottom: "10px" }}>
                    <a rel="noreferrer" target="_blank" href="https://investwithknowledge.com">Visit the Website</a>
                </p>
                <p style={{ textAlign: "center", marginTop: "10px", marginBottom: "10px" }}>
                    <a rel="noreferrer" target="_blank" href="https://apps.apple.com/us/app/invest-with-knowledge/id6761795259">Download on the App Store</a>
                </p>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The app gives you
                    important, accurate business data and explains which datapoints matter
                    and why. Every Sunday, it surfaces undervalued assets passing 40+
                    criteria based on the timeless teachings of legendary investor Benjamin
                    Graham, whose principles have guided some of the greatest investors in history.
                </p>

            </section>
        </>
    );
}

export default IWK;
